import RsaHome from "../index.js"

const routes = [
  {
    name: "RsaHome",
    path: "/homersa",
    component: RsaHome.RsaHomeConsegne,
    meta: { title: "R.S.A. - Home" },
  },
];

export default routes;